(function () {
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  document.addEventListener('click', function (e) {
    var step = e.target.closest && e.target.closest('.pqb__step');
    if (!step) return;
    e.preventDefault();
    var form = step.closest('.pqb'); if (!form) return;
    var input = form.querySelector('.pqb__input');
    var val = parseInt(input.value, 10); if (isNaN(val)) val = 1;
    val += parseInt(step.getAttribute('data-step'), 10); if (val < 1) val = 1;
    input.value = val;
  });
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('pqb')) return;
    e.preventDefault();
    var btn = form.querySelector('.pqb__add');
    var input = form.querySelector('.pqb__input');
    var idEl = form.querySelector('input[name="id"]'); if (!idEl) return;
    var id = idEl.value;
    var qty = parseInt(input.value, 10); if (isNaN(qty) || qty < 1) qty = 1;
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true'); btn.classList.add('loading');
    var cartDrawer = document.querySelector('cart-drawer');
    var sections = cartDrawer ? 'cart-drawer,cart-icon-bubble' : 'cart-icon-bubble';
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty, sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) { flash(form, data.description || data.message || 'Položku sa nepodarilo pridať.'); return; }
        try {
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents(data);
            input.value = 1;
            return;
          }
        } catch (err) {}
        window.location = root() + 'cart';
      })
      .catch(function () { window.location = root() + 'cart'; })
      .then(function () { btn.removeAttribute('aria-busy'); btn.classList.remove('loading'); });
  });
  function flash(form, msg) {
    var el = form.querySelector('.pqb__err');
    if (!el) { el = document.createElement('div'); el.className = 'pqb__err'; form.appendChild(el); }
    el.textContent = msg;
    setTimeout(function () { if (el) el.textContent = ''; }, 4000);
  }
})();
